import { render, staticRenderFns } from "./activation.vue?vue&type=template&id=5473f281&scoped=true&"
import script from "./activation.vue?vue&type=script&lang=js&"
export * from "./activation.vue?vue&type=script&lang=js&"
import style0 from "./activation.vue?vue&type=style&index=0&id=5473f281&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5473f281",
  null
  
)

export default component.exports